import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {PrintColumn} from '../components/common/AppPrintTable';

type AccessorFn<T> = (row: T) => any;

function getVal<T>(row: T, acc: keyof T | AccessorFn<T>) {
  return typeof acc === 'function' ? acc(row) : (row as any)[acc];
}

export function exportToExcelFromColumns<T>(
  columns: Array<PrintColumn<T>>,
  rows: T[],
  fileName = 'export.xlsx',
) {
  if (!rows?.length || !columns?.length) return;

  // Build a plain array of objects: { [col.title]: value }
  const data = rows.map(r => {
    const obj: Record<string, any> = {};
    columns.forEach(c => {
      obj[c.title] = getVal(r, c.accessor) ?? '';
    });
    return obj;
  });

  const ws = XLSX.utils.json_to_sheet(data);

  // Optional: set column widths roughly based on your `width`
  const colWidths = columns.map(c => ({
    wch: Math.max(8, Math.floor(((c?.width ?? 120) as number) / 8)),
  }));
  (ws as any)['!cols'] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Data');

  const buf = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });
  saveAs(blob, fileName);
}
